import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { Section } from 'common';
import strings from 'strings';
import { filterValidItems, isTruthyValue } from 'utils';

export const Languages = ({ languages = [] }) => {
  const validLanguages = filterValidItems(languages);
  if (validLanguages.length === 0) return null;

  return (
    <Section title={strings.candidates.profile.resumeTab.sections.languages}>
      {validLanguages.map(language => {
        const { name } = language;
        return (
          isTruthyValue(name) && (
            <Box key={name} display="inline-block" marginRight={1} marginBottom={1}>
              <Chip key={name} label={name} size="medium" />
            </Box>
          )
        );
      })}
    </Section>
  );
};
